/*****************************************************************************
 * 사투리 영상 지역 선택 메뉴 컴포넌트
 *
 * Copyright by 박주형 2023
 *****************************************************************************/
import {Component, EventEmitter, HostBinding, Input, Output, OnInit} from '@angular/core';
import {CITY2} from "../../shared/defines/gukeo.const";
import {CITY2_INFO_LIST} from 'src/app/shared/defines/desktop.const';
import {GlobalEventService} from "../../shared/services/global-event/global-event.service";
import {VideoService} from 'src/app/shared/services/video/video.service';

@Component({
  selector: 'app-region-menu',
  templateUrl: './region-menu.component.html',
  styleUrls: ['./region-menu.component.scss']
})
export class RegionMenuComponent implements OnInit {
  @HostBinding('class') class = 'menu-group-box';
  @HostBinding('style.display') styleBlock = 'block';
  @Input() selectedCity?: CITY2; // 선택 도시
  @Output() changeCity = new EventEmitter<CITY2>();

  // 서비스에서 받아온 도시 정보를 기반으로 필터링할 리스트
  public filteredCityInfoList: typeof CITY2_INFO_LIST = [];
  // 전체 도시 리스트 (필터 적용 전)
  public allCityInfoList = CITY2_INFO_LIST;

  constructor(
    private globalEventSvc: GlobalEventService,
    private videoSvc: VideoService,
  ) { }

  ngOnInit(): void {
    this.videoSvc.GetCityList().subscribe((cityList: CITY2[]) => {
      // 가져온 도시 목록을 집합으로 생성
      const availableCities = new Set(cityList);

      // '전국' 제외 후, 가져온 도시만 필터링
      const filtered = CITY2_INFO_LIST.filter(info => availableCities.has(info.city2) && info.city2 !== '전국');

      // '전국' 항목은 존재하면 항상 마지막에 추가
      const regionAll = CITY2_INFO_LIST.find(info => info.city2 === '전국');
      if (regionAll) {
        filtered.push(regionAll);
      }
      this.filteredCityInfoList = filtered;
    });
  }

  protected onChangeCity($event: MouseEvent, city2: CITY2) {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event, true);

    if (this.selectedCity !== city2) {
      this.selectedCity = city2;
      this.changeCity.emit(city2);
    }
  }

  /**
   * 해당 도시(cityInfo)가 filteredCityInfoList 에 포함되어 있는지 확인
   * 포함되어 있다면 사용 가능하므로 off 클래스를 제거(false)하도록 함.
   */
  public isCityAvailable(cityInfo: any): boolean {
    return this.filteredCityInfoList.some(item => item.city2 === cityInfo.city2);
  }
}
